// extracted by mini-css-extract-plugin
export default {"item-list":"SoftDrinksDesktop_item-list__qurf8","item":"SoftDrinksDesktop_item__yVHon","section":"SoftDrinksDesktop_section__bKdCL"};